export default function getDocumentStatusMeta(status = "") {
  const normalized = String(status || "").toLowerCase();

  if (normalized === "approved") {
    return {
      label: "APPROVED",
      bg: "#dcfce7",
      border: "#86efac",
      text: "#166534",
    };
  }

  if (normalized === "reupload_required") {
    return {
      label: "REUPLOAD REQUIRED",
      bg: "#ffedd5",
      border: "#fdba74",
      text: "#9a3412",
    };
  }

  if (normalized === "rejected") {
    return {
      label: "REJECTED",
      bg: "#fee2e2",
      border: "#fca5a5",
      text: "#991b1b",
    };
  }

  if (normalized === "uploading") {
    return {
      label: "UPLOADING",
      bg: "#e0f2fe",
      border: "#7dd3fc",
      text: "#075985",
    };
  }

  if (normalized === "failed") {
    return {
      label: "FAILED",
      bg: "#fee2e2",
      border: "#fca5a5",
      text: "#991b1b",
    };
  }

  if (normalized === "pending_review" || normalized === "submitted") {
    return {
      label: "PENDING REVIEW",
      bg: "#fef3c7",
      border: "#fcd34d",
      text: "#92400e",
    };
  }

  if (normalized === "selected") {
    return {
      label: "SELECTED",
      bg: "#dbeafe",
      border: "#93c5fd",
      text: "#1d4ed8",
    };
  }

  return {
    label: "MISSING",
    bg: "#f8fafc",
    border: "#cbd5e1",
    text: "#475569",
  };
}